<div
  class="reset-dialog"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="title"
>
  <div class="reset-dialog__header">
    <span class="reset-dialog__icon" aria-hidden="true">
      <span class="material-icons">delete_outline</span>
    </span>
    <button
      type="button"
      class="reset-dialog__close"
      aria-label="Close"
      (click)="onCancel()"
    >
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </div>

  <h2 class="reset-dialog__title">{{ title }}</h2>

  <fieldset class="reset-dialog__modes">
    <legend class="reset-dialog__modes-legend">{{ modeLabel }}</legend>

    <label class="reset-dialog__mode">
      <input
        type="radio"
        name="resetMode"
        [value]="dataOnlyMode"
        [checked]="selectedMode === dataOnlyMode"
        (change)="selectMode(dataOnlyMode)"
      />
      <span class="reset-dialog__mode-text">
        <span class="reset-dialog__mode-label">{{ dataOnlyLabel }}</span>
        <span class="reset-dialog__mode-hint">{{ dataOnlyHint }}</span>
      </span>
    </label>

    <label
      class="reset-dialog__mode"
      [class.reset-dialog__mode--disabled]="!fullEnabled"
    >
      <input
        type="radio"
        name="resetMode"
        [value]="fullMode"
        [disabled]="!fullEnabled"
        [checked]="selectedMode === fullMode"
        (change)="selectMode(fullMode)"
      />
      <span class="reset-dialog__mode-text">
        <span class="reset-dialog__mode-label">{{ fullLabel }}</span>
        <span class="reset-dialog__mode-hint">{{ fullHint }}</span>
        <span *ngIf="!fullEnabled" class="reset-dialog__mode-hint">{{
          fullUnavailable
        }}</span>
      </span>
    </label>
  </fieldset>

  <div class="reset-dialog__warning" role="alert">
    <p class="reset-dialog__warning-headline">{{ warningHeadline }}</p>
    <ng-container *ngIf="selectedMode === dataOnlyMode; else fullBody">
      <p>{{ dataOnlyRemoves }}</p>
      <p>{{ dataOnlyKeeps }}</p>
    </ng-container>
    <ng-template #fullBody>
      <p>{{ fullWarning }}</p>
    </ng-template>
    <p class="reset-dialog__warning-activity">{{ activityWarning }}</p>
  </div>

  <div class="reset-dialog__confirm">
    <label for="resetConfirmName" class="reset-dialog__confirm-label">
      Type <b>{{ data.companyName }}</b> to confirm
    </label>
    <input
      id="resetConfirmName"
      type="text"
      autocomplete="off"
      [placeholder]="data.companyName"
      [class.reset-dialog__input--error]="showMismatchError"
      [attr.aria-invalid]="showMismatchError"
      [value]="typedName"
      (input)="onNameInput($event)"
      (keydown.enter)="onConfirm()"
    />
    <div *ngIf="showMismatchError" class="reset-dialog__error">
      {{ mismatchMessage }}
    </div>
  </div>

  <div class="reset-dialog__actions">
    <button type="button" class="reset-dialog__btn" (click)="onCancel()">
      {{ cancelLabel }}
    </button>
    <button
      type="button"
      class="reset-dialog__btn reset-dialog__btn--danger"
      [disabled]="isConfirmDisabled"
      (click)="onConfirm()"
    >
      {{ confirmLabel }}
    </button>
  </div>
</div>
